import { HistoryItem } from '../history';
import { z } from 'zod';

export const AssetLocationType = z.object({
    id: z.string(),
    name: z.string(),
    createdOn: z.coerce.date().nullish(),
    modifiedOn: z.coerce.date().nullish(),
    deletedOn: z.coerce.date().nullish(),
    history: z.array(HistoryItem).nullish(),
});
export type AssetLocationType = z.infer<typeof AssetLocationType>;

export const AssetLocation = z.object({
    id: z.string(),
    typeId: z.string().nullish(),
    name: z.string().nullish(),
    address: z
        .object({
            streetNr: z.string(),
            line2: z.string().nullish(),
            zipCode: z.string(),
            city: z.string(),
            country: z.string(),
        })
        .nullish(),
    createdOn: z.coerce.date().nullish(),
    modifiedOn: z.coerce.date().nullish(),
    deletedOn: z.coerce.date().nullish(),
    history: z.array(HistoryItem).nullish(),
});

export type AssetLocation = z.infer<typeof AssetLocation>;
